// components/Footer.tsx
"use client"
import Link from 'next/link';
import Image from 'next/image';
import { useState } from 'react';

const Footer = ({ articles }) => {
    const currentYear = new Date().getFullYear();
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');
    
        try {
          const response = await fetch('/api/subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
          });
    
          const data = await response.json();
    
          if (response.ok) {
            setMessage(data.data.message);
            setEmail('');
          } else {
            setMessage(data.error || 'Subscription failed');
          }
        } catch (error) {
          setMessage('Network error. Please try again.');
        } finally {
          setIsLoading(false);
        }
      };

    return (
        <footer className="bg-[#16120E] text-white pt-12 pb-8">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">

                    {/* About Section */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">About Choose Palestine</h3>
                        <p className="text-gray-300">
                            Supporting Palestinian artisans and businesses through ethical commerce.
                        </p>
                        <div className="flex space-x-4">
                            <Link href="#" className="text-gray-400 hover:text-white transition">
                                <span className="sr-only">Facebook</span>
                                <Image src="/social/facebook.svg" alt="Facebook" width={24} height={24} />
                            </Link>
                            <Link href="#" className="text-gray-400 hover:text-white transition">
                                <span className="sr-only">Instagram</span>
                                <Image src="/social/instagram.svg" alt="Instagram" width={24} height={24} />
                            </Link>
                            <Link href="#" className="text-gray-400 hover:text-white transition">
                                <span className="sr-only">Twitter</span>
                                <Image src="/social/twitter.svg" alt="Twitter" width={24} height={24} />
                            </Link>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Quick Links</h3>
                        <ul className="space-y-2">
                            <li><Link href="/about" className="text-gray-300 hover:text-white transition">About Us</Link></li>
                            <li><Link href="/products" className="text-gray-300 hover:text-white transition">Our Products</Link></li>
                            <li><Link href="/impact" className="text-gray-300 hover:text-white transition">Our Impact</Link></li>
                            <li><Link href="/contact" className="text-gray-300 hover:text-white transition">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* SEO Articles */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Learn More</h3>
                        <ul className="space-y-2">

                            {articles && articles.map((article: any) => (
                                <li key={article._id}>
                                    <Link href={`/articles/${article.slug?.current}`} className="text-gray-300 hover:text-white transition">
                                        {article.title}
                                    </Link>
                                </li>
                            ))}

                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div className="space-y-4">
                        <h3 className="text-lg font-semibold">Stay Updated</h3>
                        <p className="text-gray-300">
                            Subscribe to our newsletter for new products and stories.
                        </p>
                        <form onSubmit={handleSubmit} className="space-y-2">
                            <div className="flex">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Your email"
                                    className="px-4 py-2 rounded-l-md text-white w-full focus:outline-none"
                                    required
                                />
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="bg-green-600 hover:bg-emerald-700 px-4 py-2 rounded-r-md transition disabled:opacity-50"
                                >
                                    {isLoading ? 'Sending...' : 'Subscribe'}
                                </button>
                            </div>
                            {message && (
                                <p className={`text-sm ${message.includes('Thank you') ? 'text-green-400' : 'text-red-400'}`}>
                                    {message}
                                </p>
                            )}
                        </form>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center">
                    <div className="flex items-center space-x-4 mb-4 md:mb-0">
                        {/*<Link href="/privacy" className="text-gray-400 hover:text-white text-sm transition">
                            Privacy Policy
                        </Link>
                        <Link href="/terms" className="text-gray-400 hover:text-white text-sm transition">
                            Terms of Service
                        </Link>*/}

                    </div>
                    <p className="text-gray-400 text-sm">
                        © {currentYear} Choose Palestine. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;